module.exports = __webpack_public_path__ + "static/media/Internationalcase8.ac3d8b9b.png";